/**
 * dates.js — une date en texte, lue dans le fuseau du poste
 *
 * `new Date(...).toISOString().slice(0, 10)` est le piège le plus discret du
 * panel : `toISOString()` passe en UTC, et nous sommes à UTC+1 ou UTC+2. Le
 * 30 septembre à minuit heure de Paris s'écrit donc « 2026-09-29 ».
 *
 * Il a coûté un mois de rapport. Le raccourci « Mois dernier » de la page
 * Rémunérations calculait la fin du mois avec `new Date(a, m + 1, 0)` — le 30
 * septembre à minuit, heure locale — puis l'écrivait en UTC : la période
 * envoyée au serveur s'arrêtait au **29**. Tous les attachements, tous les
 * revenus et tous les devis sortis par ce bouton perdaient le dernier jour du
 * mois, sans que rien ne le signale. Pour septembre seul : 22 lignes, dont 14
 * facturées, 4 398,90 € de revenu Covage et 2 557,32 € de coût technicien —
 * et les deux devis du 30 (O251008_15360 et O260803_04651), qu'on a cherchés
 * en vain dans la liste.
 *
 * Ailleurs le décalage ne dure que deux heures, mais il est de même nature :
 * entre minuit et 2 h, « aujourd'hui » rendait hier. Une date d'intervention
 * du jour passait pour échue, et une échéance de SAV pour dépassée.
 *
 * D'où ce module : une seule façon d'écrire une date, et plus de
 * `toISOString()` sur une date qu'on veut lire en heure locale.
 */

/** Le jour de `d`, tel qu'on le lit sur place : « 2026-09-30 ». */
export function jourLocal(d) {
  const x = d instanceof Date ? d : new Date(d);
  return x.getFullYear()
    + '-' + String(x.getMonth() + 1).padStart(2, '0')
    + '-' + String(x.getDate()).padStart(2, '0');
}

/** Aujourd'hui, ici. */
export function aujourdhui() {
  return jourLocal(new Date());
}

/** Le premier jour du mois de `d`. */
export function debutDuMois(d = new Date()) {
  return jourLocal(new Date(d.getFullYear(), d.getMonth(), 1));
}

/**
 * Le dernier jour du mois de `d`.
 *
 * Le jour 0 du mois suivant : c'est la seule façon de ne pas avoir à savoir
 * si le mois fait 28, 29, 30 ou 31 jours.
 */
export function finDuMois(d = new Date()) {
  return jourLocal(new Date(d.getFullYear(), d.getMonth() + 1, 0));
}
